module.exports = __webpack_public_path__ + "static/cells-f2a223e27868554f59158c577a74bc80.jpeg";